module.exports = __webpack_public_path__ + "static/media/fox.499d8b53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/fox.svg
// module id = 131
// module chunks = 0